import React from "react";
import styles from "./InviteToWorkspace.module.css";
import ModalBlackBgTemplate from "../../ModalBlackBgTemplate/ModalBlackBgTemplate";
import HeaderCard from "../../HeaderCard/HeaderCard";
import Button from "../../Button/Button";
import { ReactComponent as TwoPeopleGreen } from "../../../assets/TwoPeopleGreen.svg";
import { ReactComponent as StarIcon } from "../../../assets/RoundedStar.svg";
import { useTranslation } from "react-i18next";
import EditableInput from "../../AccountSettings/EditableInput/EditableInput";
import CustomDropdown from "../../CustomDropdown/CustomDropdown";
const InviteToWorkspace = ({ setShowInviteToWorkspace,userToInvite,setUserToInvite,setShowMergePlan }) => {
  const [t] = useTranslation("accountSetting");

  const close = () => {
    setShowInviteToWorkspace(false);
  };

  const handleChange = ({ name, newValue }) => {
    const updatedData = { ...userToInvite, [name]: newValue };
    setUserToInvite(updatedData);
  };

  return (
    <ModalBlackBgTemplate
      close={close}
      customStyle={{
        maxWidth: "700px",
        width: "100vw",
        height: "80vh",
        minHeight: "80vh",
      }}
    >
      <HeaderCard
        title={`${t("inviteTo")} `}
        setState={setShowInviteToWorkspace}
        titleStyle={{ fontSize: " clamp(9px, 1.5vw, 18px)" }}
      >
        <Button type="white">{t("cancel")}</Button>
        <Button type="green" action={() => setShowInviteToWorkspace(true)}>
          {t("invite")}
        </Button>
      </HeaderCard>
      <div className={styles.InviteToWorkspaceContent}>
        <div className={styles.workspaceSectionLabel}>
          <div className={styles.mergPlanContainer}>
            <div>
              <p>{t("mergePlan")}</p>

              <div className={styles.mergePlanSwitchContainer}>
                <StarIcon className={true && styles.activeMerge} />
                <label className={styles.switch}>
                  <input
                    type="checkbox"
                    checked={userToInvite?.mergePlanChecked}
                    onChange={(e) => {
                        if(userToInvite?.mergePlanChecked){
                            setUserToInvite((prev) => ({
                                ...prev,
                                mergePlanChecked: e.target.checked,
                            }));
                        }else{
                            setShowMergePlan(true)
                        }
                    }}
                  />
                  <span className={`${styles.slider} `}></span>
                </label>
              </div>
            </div>

            <div>
              <p>{t("email")}</p>
              <div className={styles.inputContainer}>
                <TwoPeopleGreen />
                <input type="text" placeholder="example@gmail.com" value={userToInvite.userEmail} onChange={(e) => handleChange({name:'userEmail',newValue: e.target.value})}/>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.workspaceSectionLabel}>
          <p>{t("invitationEmail")}</p>

          <Button headerStyle={{ borderRadius: "999px" }} type="white">
            {t("changeDefault")}
          </Button>
        </div>
        <div className={`${styles.workspaceSectionLabel} ${styles.editableInputContainer}`}>
          <EditableInput
            placeholder={t("unknow")}
            label={t("name")}
              value={userToInvite?.name}
            name="name"
              onSave={handleChange}
            oneRow={true}
            customStyles={styles.noPadding}
          />
        </div>
        <div className={`${styles.workspaceSectionLabel} ${styles.editableInputContainer}`}>
          <EditableInput
            placeholder={t("unknow")}
            label={t("rol")}
              value={userToInvite?.rol}
            name="rol"
              onSave={handleChange}
            oneRow={true}
            customStyles={styles.noPadding}
          />
        </div>

        <div className={styles.workspaceSectionLabel}>
          <div>
            <p>{t("access")}</p>
            <span className={styles.descSection}>{t("requestAccess")}</span>
          </div>

          <div>
            <CustomDropdown
              placeholder={t('selectAccessType')}
              options={["admin"]}
              selectedOption={userToInvite.accessType}
              setSelectedOption={(option) => {
                setUserToInvite((prev) => ({
                    ...prev,
                    accessType:option
                }))
      
              }}
            />
          </div>
        </div>

        <div className={styles.workspaceSectionLabel}>
          <p>{t("syncAutomations")}</p>

          <div>
            <label className={styles.switch}>
              <input
                type="checkbox"
                checked={userToInvite?.syncAutomate}
                onChange={(e) => {
                  setUserToInvite((prev) => ({
                    ...prev,
                    syncAutomate: e.target.checked,
                  }));
                }}
              />
              <span className={`${styles.slider} ${styles.bgBlack}`}></span>
            </label>
          </div>
        </div>


        <div className={styles.workspaceSectionLabel}>
          <p>{t("syncContacts")}</p>

          <div>
            <label className={styles.switch}>
              <input
                type="checkbox"
                checked={userToInvite?.syncContacts}
                onChange={(e) => {
                  setUserToInvite((prev) => ({
                    ...prev,
                    syncContacts: e.target.checked,
                  }));
                }}
              />
              <span className={`${styles.slider} ${styles.bgBlack}`}></span>
            </label>
          </div>
        </div>

        
      </div>
    </ModalBlackBgTemplate>
  );
};

export default InviteToWorkspace;
